/**
 * API Configuration Module
 * Single source of truth for API Base URL resolution across environments (Local, Dev, QA, UAT, Staging, Production).
 */

const getEnvVar = (val) => (val && val.trim() ? val.trim() : null);

const ENV_URLS = {
  local: getEnvVar(process.env.REACT_APP_LOCAL_API_URL) || 'http://localhost:3001',
  development: getEnvVar(process.env.REACT_APP_DEV_API_URL) || 'https://betagate.kubercrypto.io',
  qa: getEnvVar(process.env.REACT_APP_QA_API_URL) || getEnvVar(process.env.REACT_APP_DEV_API_URL) || 'https://betagate.kubercrypto.io',
  staging: getEnvVar(process.env.REACT_APP_STAGING_API_URL) || 'https://kuberpay-ramp-api-staging.octallabs.com',
  uat: getEnvVar(process.env.REACT_APP_UAT_API_URL) || getEnvVar(process.env.REACT_APP_STAGING_API_URL) || 'https://webhook.uatzenithpay.in',
  production: getEnvVar(process.env.REACT_APP_PROD_API_URL) || 'https://apigate.kubercrypto.io',
};

/**
 * Detect environment from window.location.hostname if available
 * @returns {string} Environment name
 */
export function detectEnvironmentFromHostname() {
  if (typeof window === 'undefined' || !window.location || !window.location.hostname) {
    return 'local';
  }

  const hostname = window.location.hostname.toLowerCase();

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'local';
  }
  if (hostname.includes('qa')) {
    return 'qa';
  }
  if (hostname.includes('uat')) {
    return 'uat';
  }
  if (hostname.includes('staging') || hostname.includes('stg') || hostname.includes('octallabs')) {
    return 'staging';
  }
  if (hostname.includes('dev') || hostname.includes('beta')) {
    return 'development';
  }

  return 'production';
}

/**
 * Get current active environment name
 * Priority: REACT_APP_ENV -> Hostname detection -> 'local'
 * @returns {string}
 */
export function getEnvironment() {
  const envVar = process.env.REACT_APP_ENV;
  if (envVar && envVar.trim()) {
    return envVar.trim().toLowerCase();
  }
  return detectEnvironmentFromHostname();
}

/**
 * Get API Base URL
 * Priority: REACT_APP_API_URL -> ENV_URLS[environment] -> ENV_URLS.local
 * @returns {string}
 */
export function getApiBaseUrl() {
  // Direct explicit override
  if (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL.trim()) {
    return process.env.REACT_APP_API_URL.trim();
  }

  const currentEnv = getEnvironment();
  return ENV_URLS[currentEnv] || ENV_URLS.local;
}

export const API_BASE_URL = getApiBaseUrl();
export const CURRENT_ENV = getEnvironment();

export default {
  getApiBaseUrl,
  getEnvironment,
  API_BASE_URL,
  CURRENT_ENV,
  ENV_URLS,
};
